import Button from '../Button';
import { useEffect, useState } from 'react';
import SortPopup, { SORT_POPUP_NAME } from '@/components/layout/CatalogFilters/SortPopup';
import { useSetOpenedPopupsState } from '@/atoms/opened-popups';

const BlogSort = () => {
    const [portal, setPortal] = useState<Element>();
    const { openPopup } = useSetOpenedPopupsState();
    useEffect(() => {
        const portalEl = document.querySelector<Element>('.js-blog-sort-popup-portal');
        if (portalEl) {
            setPortal(portalEl);
        }
    }, []);

    return (
        <div className="blog-sort">
            <Button
                variant="primary"
                className="catalog-filter-btn blog-filter-btn"
                size="sm"
                onClick={() => {
                    openPopup(SORT_POPUP_NAME);
                }}
            >
                Сортировка
            </Button>
            <div className="blog-sort-popup-portal js-blog-sort-popup-portal" />
            {portal && (
                <SortPopup
                    methods={[
                        {
                            name: 'новые публикации',
                            value: 'published_at',
                            postfix: 'desc',
                        },
                        {
                            name: 'старые публикации',
                            value: 'published_at',
                            postfix: 'asc',
                        },
                    ]}
                    portal={portal}
                />
            )}
        </div>
    );
};

export default BlogSort;
